import getNodeLength from './getNodeLength';
import getPreviousNodesFromPath from './getPreviousNodesFromPath';

var reduceNodesLength = function reduceNodesLength(memo, block) {
  return memo + getNodeLength(block);
};

export default function convertPathToOffset(document, path) {
  var textOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return getPreviousNodesFromPath(document, path).reduce(reduceNodesLength, textOffset);
}